import { useEffect, useState } from "react";
import Logo from "@/components/feature/Logo";
import { NAV_ITEMS, WA_LINKS } from "@/constants/site";

export default function Header() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <header className="sticky top-0 z-40 w-full border-b border-malva/25 bg-ink">
      <div className="flex h-16 w-full items-center justify-between px-4 md:h-20 md:px-8">
        <Logo />

        <nav className="hidden items-center gap-8 md:flex">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className="text-sm font-medium tracking-wide text-cream/85 transition-colors hover:text-peach"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex">
          <a
            href={WA_LINKS.reservar}
            target="_blank"
            rel="noopener"
            className="inline-flex min-h-[44px] items-center justify-center gap-2 whitespace-nowrap rounded-md bg-peach px-6 text-sm font-semibold text-ink transition-colors hover:bg-[#eeb987]"
          >
            <i className="ri-whatsapp-fill text-base" aria-hidden="true" />
            Escríbenos por WhatsApp
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen(true)}
          aria-label="Abrir menú"
          className="flex h-11 w-11 items-center justify-center rounded-md text-cream md:hidden"
        >
          <i className="ri-menu-line text-2xl" aria-hidden="true" />
        </button>
      </div>

      {open ? (
        <div className="fixed inset-0 z-50 flex flex-col bg-ink md:hidden">
          <div className="flex h-16 w-full items-center justify-between px-4">
            <Logo />
            <button
              type="button"
              onClick={() => setOpen(false)}
              aria-label="Cerrar menú"
              className="flex h-11 w-11 items-center justify-center rounded-md text-cream"
            >
              <i className="ri-close-line text-2xl" aria-hidden="true" />
            </button>
          </div>

          <nav className="flex flex-1 flex-col items-center justify-center gap-7 px-6">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setOpen(false)}
                className="font-serif text-3xl text-cream transition-colors hover:text-peach"
              >
                {item.label}
              </a>
            ))}

            <a
              href={WA_LINKS.reservar}
              target="_blank"
              rel="noopener"
              onClick={() => setOpen(false)}
              className="mt-4 inline-flex min-h-[52px] w-full max-w-xs items-center justify-center gap-2 whitespace-nowrap rounded-md bg-wa px-6 text-base font-semibold text-white"
            >
              <i className="ri-whatsapp-fill text-lg" aria-hidden="true" />
              Escríbenos por WhatsApp
            </a>
          </nav>
        </div>
      ) : null}
    </header>
  );
}